(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('GroupePlanning', GroupePlanning);

    GroupePlanning.$inject = ['$resource'];

    function GroupePlanning ($resource) {
        var resourceUrl =  'api/groupes-planning/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getEnabled': {
                method: 'GET',
                isArray: true,
                url: '/api/groupes-planning/get-enabled'
            },
            'update': { method:'PUT' }
        });

    }
})();
